// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__gXHEB","legacyBtn":"MutateMid_legacyBtn__2PUZ9"};